import { useCallback } from "react";

import { postHTML } from "@/lib/aws-amplify/storage";
import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { PlanI18nArticleUpdate_DesignPage_Mutation } from "./mutation";

type Props = {
	hotelID: string;
	planID: string;
	langCode: LangCode;
};

export const usePlanI18nArticleUpdateMutation = ({ hotelID, planID, langCode }: Props) => {
	const { mutationFunc } = useCustomMutation(PlanI18nArticleUpdate_DesignPage_Mutation);
	const onUpdate = useCallback(
		async ({ articleHTML }: { articleHTML: string }) => {
			const { s3Object } = await postHTML({
				html: articleHTML,
				lang: langCode,
				hotelID,
				resourceID: planID,
			});

			return await mutationFunc({
				variables: {
					input: {
						hotelID,
						planID,
						article: s3Object,
						articleTitle: "",
						lang: langCode,
					},
				},
			});
		},
		[hotelID, langCode, mutationFunc, planID],
	);

	return {
		onUpdate,
	};
};
